import { z } from 'zod';

// Backend returns various case formats - accept any string and normalize to uppercase
// This makes validation flexible and resilient to backend changes
export const zAlertSeverity = z
  .string()
  .transform((val) => val.toUpperCase() as 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL');

// Accept any status value and normalize to uppercase with underscores
// Maps common variations: "Active" -> "ACTIVE", "In Progress" -> "IN_PROGRESS"
export const zAlertStatus = z.string().transform((val) => val.toUpperCase().replace(/\s+/g, '_'));

export const zFleetHealthAlert = z.object({
  id: z.string(),
  vin: z.string(),
  repairPartnerId: z.string().optional().default(''), // Backend may not return this in list
  severity: zAlertSeverity,
  subject: z.string(),
  message: z.string().optional().default(''), // Backend may not return this in list
  status: zAlertStatus,
  createdAt: z.string(),
  updatedAt: z.string().optional().default(''), // Backend may not return this in list
  workOrderIdentifier: z.string().optional(),
});

export const zFleetHealthAlertArray = z.array(zFleetHealthAlert);

export const zAlertListResponse = z.object({
  items: z.array(zFleetHealthAlert),
  totalCount: z.number(),
  pageNumber: z.number(),
  pageSize: z.number(),
  currentPageCount: z.number(),
  totalPages: z.number(),
});

/**
 * UUID v4 validation regex pattern
 */
const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Validates if a string is a valid UUID v4 format
 * @param value - String to validate
 * @returns true if valid UUID v4, false otherwise
 */
export const isValidUUID = (value: string): boolean => {
  return UUID_V4_REGEX.test(value);
};
